module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['panel', _vm.panelType]
  }, [_c('div', {
    class: ['panel-heading', {
      'accordion-toggle': _vm.inAccordion
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.inAccordion && _vm.toggle()
      }
    }
  }, [_vm._t("header", [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.header))])])], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "panel-collapse"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6690733a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6690733a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Panel.vue
// module id = 138
// module chunks = 0